export const Bio = {
  name: "Aditya Singh",
  roles: [
    "Operating Sys Developer",
    "Backend Developer",
    "Android Developer",
    "Programmer",
  ],
  description:
    "An analytical thinker with a keen eye for detail, committed to delivering high-quality solutions, and continuously honing skills to adapt to the dynamic and evolving tech landscape. I'm Eager to contribute innovative ideas, solve challenges, and embark on a successful journey in the world of software development, with a strong commitment to professional growth and achievement.",
  github: "https://github.com/Adii-5442",
  resume:
    "https://drive.google.com/file/d/1fAMSxtouXILNuaK2WooCROSC5Ph1NbMs/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/aditya-singh-8b769b225/",
  twitter: "https://twitter.com/AdityaS2708321",
  insta: "https://www.instagram.com/adii_5442/",
  facebook: "https://www.facebook.com/profile.php?id=100009017488635",
};

export const skills = [
  {
    title: "System Development",
    skills: [
      {
        name: "Assembly",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/American_Society_for_Metals_%28ASM%29_Logo.jpg/640px-American_Society_for_Metals_%28ASM%29_Logo.jpg",
      },
      {
        name: "C",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/1/19/C_Logo.png/640px-C_Logo.png",
      },
      {
        name: "CMake",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/1/13/Cmake.svg/640px-Cmake.svg.png",
      },
      {
        name: "MakeFile",
        image:
          "https://cdn.icon-icons.com/icons2/2107/PNG/512/file_type_makefile_icon_130408.png",
      },
      {
        name: "C++",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/ISO_C%2B%2B_Logo.svg/640px-ISO_C%2B%2B_Logo.svg.png",
      },
    ],
  },
  {
    title: "Android",
    skills: [
      {
        name: "React-Native",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "Kotlin",
        image:
          "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
      },
      {
        name: "XML",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
      },
      {
        name: "Android Studio",
        image:
          "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "PHP",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/2/27/PHP-logo.svg/1200px-PHP-logo.svg.png",
      },
      {
        name: "Graph Ql",
        image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Electron Js",
        image:
          "https://www.vectorlogo.zone/logos/electronjs/electronjs-icon.svg",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "TypeScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/4/4c/Typescript_logo_2020.svg",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
    ],
  },

  {
    title: "Others",
    skills: [
      {
        name: "Machine Learning",
        image:
          "https://www.vectorlogo.zone/logos/tensorflow/tensorflow-icon.svg",
      },
      {
        name: "Microservices",
        image:
          "https://cdn4.vectorstock.com/i/1000x1000/98/63/microservices-vector-28349863.jpg",
      },
      {
        name: "Git",
        image: "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
    ],
  },
];

export const experiences = [
  {
    id: -1,
    img: "https://www.smallcase.com/wp-content/uploads/2023/07/smallcase-logo-full-vertical-blue-background.png",
    role: "Software Development Intern",
    company: "Smallcase",
    date: "April 2024 - Current",
    desc: "Automated critical manual scripts, significantly reducing customer bugs and enhancing system reliability. I designed and developed responsive interfaces for React and React Native apps, improving user accessibility and experience. I tackled complex backend tasks, optimizing performance and ensuring seamless integration with front-end components. Additionally, I collaborated with cross-functional teams to deliver high-quality, scalable solutions, contributing to the company's growth and success.",
    skills: [
      "ReactJS",
      "Kafka",
      "AWS",
      "Postgres",
      "JavaScript",
      "TypeScript",
      "Node Js",
      "Express Js",
      "Python",
      "Django",
    ],
  },
  {
    id: 0,
    img: "https://avatars.githubusercontent.com/u/88003102?s=200&v=4",
    role: "Backend Developer",
    company: "Prestige Perfections",
    date: "Jan 2024 - Current",
    desc: "Lead the development of robust backend solutions using a stack encompassing PHP, Python, and various cutting-edge technologies for multiple high-profile projects at Prestige Perfections.",
    skills: [
      "Azure",
      "AWS",
      "Postgres",
      "PHP",
      "TypeScript",
      "Node Js",
      "Express Js",
      "Python",
      "Django",
    ],
  },
  {
    id: 1,
    img: "https://www.sharksigma.com/static/media/invstoLogo.d249ac33.svg",
    role: "Full Stack Development Intern",
    company: "Invsto",
    date: "July 2023 - Dec 2023",
    desc: "Architected and implemented a comprehensive Unified Trading Interface utilizing the MERN stack, streamlining operations and enhancing user experience for the entire organization.",
    skills: [
      "ReactJS",
      "AWS",
      "Postgres",
      "JavaScript",
      "TypeScript",
      "Node Js",
      "Express Js",
      "Python",
      "Django",
    ],
  },
  {
    id: 2,
    img: "data:image/png;base64,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",
    role: "Software Development Engineer (SDE) Intern",
    company: "OlaGate",
    date: "March 2023 - July 2023",
    desc: "Worked on various live mobile apps under OlaGate and implemented various features and custom notifications",
    skills: [
      "React-Native",
      "AWS",
      "Firebase",
      "Postgres",
      "JavaScript",
      "TypeScript",
      "Node Js",
      "Next Js",
    ],
  },
  {
    id: 3,
    img: "https://media.licdn.com/dms/image/C560BAQH_t6-ATxNWXg/company-logo_200_200/0/1570415751115?e=2147483647&v=beta&t=j-fNasjDHorg2hROH2xJ9e50Eq4AWxhweB_9TFS2Cvo",
    role: "Software Development Engineer (SDE) Intern",
    company: "Clout News - Prestige Perfections",
    date: "December 2022 - April-23",
    desc: "Worked on Clout news Mobile app,implemented robust subscription system and essential admin control features.\n Integrated payment gateway with Dynamic Ranking system.",
    skills: [
      "NodeJs",
      "React-Native",
      "TailWind CSS",
      "Redux",
      "TypeScript",
      "JavaScript",
    ],
  },
  {
    id: 4,
    img: "https://play-lh.googleusercontent.com/sETI_UvRqKM4aKYH0no6BqwZC2A2ZujC_yMp9bRF0R8eKhLNdbtuPvFc7QaibkLImA=w240-h480-rw",
    company: "Meld Date",
    date: "June 2023 - July 2023",
    desc: "Built an employee management full stack web app used Docker and deployed on AWS ec2. I was the top performer in the program.",
    skills: [
      "Expo",
      "NodeJs",
      "Material UI",
      "JavaScript",
      "TypeScript",
      "Firebase",
      "MongoDB",
      "React-Native",
      "Android",
    ],
  },
  {
    id: 5,
    img: "data:image/jpeg;base64,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",
    company: "Upyojan PVT LTD",
    date: "March 2022 - Aug 2022",
    desc: "Developed Admin application for sales management. Spearheaded the implementation of dynamic graphs and visually captivating visualizations, empowering diverse users to effortlessly comprehend and leverage critical statistics and insights.",
    skills: [
      "NodeJs",
      "Material UI",
      "JavaScript",
      "TypeScript",
      "Firebase",
      "MongoDB",
      "React-Native",
      "Android",
    ],
  },
  {
    id: 6,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/girlScript.jpeg?alt=media&token=e656a621-cf3c-4230-bf0f-e74b4cec6035",
    role: "Open Source Contributor ",
    company: "Google Summer of Code",
    date: "May 2023 - Present",
    desc: "Contributing to different open-source projects and learn from industry experts",
  },
  {
    id: 7,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/gdsc.jpeg?alt=media&token=c162329c-efaa-4be8-a173-8d3f4c48ea70",
    role: "Android Developer",
    company: "GDSC IET",
    date: "Nov2021 - Present",
    desc: "As an Android developer at the Google Developers Student Club (GDCS), I have had the opportunity to work on exciting projects and collaborate with talented developers who share my passion for technology. Through my involvement with GDCS, I have also had the opportunity to host and participate in numerous events, including hackathons, study jams, and workshops.",
    skills: [
      "Leadership",
      "Mobile Application Development",
      "Kotlin",
      "XML",
      "Figma",
    ],
  },
];

export const education = [
  {
    id: 0,
    img: "https://upload.wikimedia.org/wikipedia/commons/4/47/Ietlogo.png",
    school: "Institute of Engineering & Technology, Lucknow",
    date: "Aug 2021 - Sep 2025",
    grade: "8.50 CGPA",
    desc: "I am currently pursuing a Bachelor's degree in Computer Science and Engineering at IET Lucknow. I have completed 6 semesters and have a CGPA of 8.50. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others. I am also a member of the Google Developers Student Club (GDSC) at IET, where I am learning and working on exciting projects with a team of talented developers.",
    degree:
      "Bachelor of Technology - BTech, Computer Science and Engineering | Specialization : Artificial Intelligence",
  },
  {
    id: 1,
    img: "https://4.bp.blogspot.com/-cKfxHZBZKNo/WIQaN1S0CwI/AAAAAAAAFAc/8CVg_TVmG6ES8uVepCpzzYmwKyxvmyR7gCLcB/s1600/kvs-logo-with-bg.png",
    school: "Kendriya Vidyalaya Lucknow",
    date: "Apr 2020 - Apr 2021",
    grade: "91.04%",
    desc: "I completed my class 12 high school education at KV School, Lucknow, where I studied Science with Computer Science.",
    degree: "CBSE(XII), Science with Computer",
  },
  {
    id: 2,
    img: "https://4.bp.blogspot.com/-cKfxHZBZKNo/WIQaN1S0CwI/AAAAAAAAFAc/8CVg_TVmG6ES8uVepCpzzYmwKyxvmyR7gCLcB/s1600/kvs-logo-with-bg.png",
    school: "Kendriya Vidyalaya Lucknow",
    date: "Apr 2019 - Apr 2020",
    grade: "93%",
    desc: "I completed my class 10 education at KV School, Lucknow where I studied Science with Computer Application.",
    degree: "CBSE(X), Science with Computer",
  },
];

export const projects = [
  {
    id: 9,
    title: "Operating System x86",
    date: "Sept 2023 - Ongoing",
    description:
      "An x86 operating system is a foundational software system designed to manage computer hardware and provide a user-friendly interface for running applications on x86-based computer systems. It facilitates tasks like process management, memory allocation, device interaction, and file storage, ensuring the efficient and secure operation of the computer. As the bridge between hardware and software, it plays a vital role in enabling users to interact with and utilize their computers effectively.",
    image:
      "https://raw.githubusercontent.com/Adii-5442/OS_x86/main/Screenshot%20from%202023-10-14%2011-29-58.png",
    tags: ["Assembly", "C", "MakeFile"],
    category: "Operating System",
    github: "https://github.com/Adii-5442/OS_x86.git",
    member: [
      {
        name: "Aditya Singh",
        img: "https://avatars.githubusercontent.com/u/96639891?s=400&u=906da71ad8493ce0cce59270378b8b7860b9f746&v=4",
        linkedin: "https://www.linkedin.com/in/aditya-singh-b89a791b3/",
        github: "https://github.com/Adii-5442/",
      },
    ],
  },
  {
    id: 0,
    title: "Compiler.Fire",
    date: "Oct 2023 - Ongoing",
    description:
      "A compiler for .fire extensions in C++ involves developing software that translates source code written in the custom .fire programming language into executable machine code. This project includes designing the language, building a lexer, parser, semantic analyzer, code generator, and linker to produce executable programs from .fire source code.",
    image:
      "https://raw.githubusercontent.com/Adii-5442/Compiler.FIRE/main/coollogo_com-23319162.png",
    tags: ["C++", "Assembly", "CMake", "C++", "Clion"],
    category: "Compiler",
    github: "https://github.com/Adii-5442/Compiler.FIRE",
    member: [
      {
        name: "Aditya Singh",
        img: "https://avatars.githubusercontent.com/u/96639891?s=400&u=906da71ad8493ce0cce59270378b8b7860b9f746&v=4",
        linkedin: "https://www.linkedin.com/in/aditya-singh-b89a791b3/",
        github: "https://github.com/Adii-5442/",
      },
    ],
  },
  {
    id: 1,
    title: "Talk 2 Icons",
    date: "Oct 2022 - Present",
    description:
      "A web application which allows users to engage in interactive conversations with custom AI characters, offering dynamic and lifelike interactions. This platform combines natural language processing and custom AI personalities for an engaging and personalized user experience.",
    image:
      "https://raw.githubusercontent.com/Adii-5442/Talk-2-Icons/main/public/home.png",
    tags: [
      "TypeScript",
      "React JS",
      "Node Js",
      "NEXT Js",
      "Tailwind CSS",
      "Redis",
      "AWS",
      "SQL Server",
    ],
    category: "web app",
    github: "https://github.com/Adii-5442/Talk-2-Icons",
    webapp: "https://talk-2-icons.vercel.app/",
  },
  {
    id: 2,
    title: "FarmFare",
    date: "Jan 2023 - Mar 2023",
    description:
      "FarmFare is a groundbreaking mobile app that bridges the gap between local farmers and consumers in your community. With FarmFare, farmers can easily showcase their fresh, locally grown produce, meats, and other agricultural products, while consumers gain direct access to the finest, farm-fresh goods in their area. This innovative platform not only supports local agriculture but also fosters a stronger sense of community and sustainability. Discover the bounty of your region with FarmFare and help build a healthier, more vibrant food ecosystem.",
    image:
      "https://raw.githubusercontent.com/Adii-5442/FarmFare/main/FarmFare.jpg",
    tags: [
      "Python",
      "Firebase",
      "Open-CV",
      "My-SQL",
      "Android",
      "React-Native",
    ],
    category: "android app",
    github: "https://github.com/Adii-5442/FarmFare",
    member: [
      {
        name: "Aditya Singh",
        img: "https://avatars.githubusercontent.com/u/96639891?s=400&u=906da71ad8493ce0cce59270378b8b7860b9f746&v=4",
        linkedin: "https://www.linkedin.com/in/aditya-singh-8b769b225/",
        github: "https://github.com/Adii-5442/",
      },
    ],
  },
  {
    id: 3,
    title: "Park With Ease",
    date: "Apr 2023 - Sept 2023",
    description:
      "A mobile application for small scale parking owners to replace the existing paper slips for managing vehicles. Park With Ease aims to provide a revolutionary solution which eradicates the risk of loosign the slips and helps the environment by reducing the use of papers",
    image:
      "https://raw.githubusercontent.com/Adii-5442/Park-With-Ease/main/park.jpg",
    tags: ["Javascript", "TypeScript", "React-Native", "MYSQL", "Firebase"],
    category: "android app",
    github: "https://github.com/Adii-5442/Park-With-Ease",
  },
  {
    id: 10,
    title: "The Coding Buddy",
    date: "Jun 2022 - Jul 2022",
    description:
      "An Android app for students to get updated with all the latest upcoming programming contests on various websites",
    image:
      "https://raw.githubusercontent.com/Adii-5442/CodingBuddy/main/Screenshot%20from%202023-10-14%2017-14-07.png",
    tags: ["React Native", "JavaScript", "Axios", "TypeScript", "Ruby"],
    category: "android app",
    github: "https://github.com/Adii-5442/CodingBuddy",
  },
  {
    id: 4,
    title: "Driver Drowsiness Detection",
    date: "Jul 2022",
    description:
      "A machine learning model to play a sound when the driver is detected as drowsy.",
    image:
      "https://img.freepik.com/free-vector/set-realistic-part-female-human-face-with-open-closed-eyes_98292-7869.jpg",
    tags: ["Python", "Machine Learning", "OpenCV"],
    category: "web app",
    github: "https://github.com/Adii-5442/Driver-Drowsiness-Detection.git",
  },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
